<template>
  <div class="steps-container">
    <transition-group name="fade" tag="div">
      <div v-for="(step, index) in stepsData" :key="step.step" class="step-wrapper">
        <div class="step-container">
          <div class="step-marker">
            <span :class="{ inactive: currentStep !== index }" class="section-icon"
              ><img v-if="step.icon" :src="step.icon" />
              <div v-else class="bullet-point"></div>
            </span>
          </div>
          <div :class="['step-content', { inactive: currentStep !== index }]">
            <div class="title">{{ step.title }}</div>
            <p>{{ step.description }} <span></span></p>
          </div>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
export default {
  name: 'PaymentSteps',
  props: {
    currentStep: {
      type: Number,
      default: 0
    },
    stepsData: {
      type: Array,
      default: []
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.step-container {
  display: flex;
  // justify-content: flex-end;
  @media (max-width: 767px) {
    justify-content: center;
  }

  .step-marker {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    @include rtl-sass-prop(margin-right, margin-left, 10px);

    .section-icon {
      .bullet-point {
        width: 7px;
        height: 7px;
        border-radius: 50%;
        background-color: $black;
        z-index: 1;
        transition: background-color 1s ease;
      }

      img {
        width: 26px;
        transition: opacity 0.5s ease-in-out;
      }
      &.inactive {
        img {
          opacity: 0.3;
        }
        .bullet-point {
          background-color: rgba(0, 0, 0, 0.2);
        }
      }
    }
  }
  .step-content {
    margin-bottom: 40px;
    transition: color 1s ease;
    width: 100%;
    // max-width: 70%;
    max-width: 264px;

    @media (max-width: 960px) {
      // max-width: 80%;
    }
    @media (max-width: 767px) {
      margin-bottom: 1rem;
    }
    p {
      line-height: 1.5;
    }
    // p span:after {
    //   content: '隱藏補足字隱藏補足字隱藏補足字隱藏補足字隱藏補足字'; /* 填充需要補足的字數，字數不足兩行會影響到排版 */
    //   color: transparent; /* 讓文字透明 */
    //   word-break: break-word;
    //   white-space: normal;
    // }
    .title {
      margin-top: 0;
      padding-bottom: 0.5rem;
      margin-bottom: 17px;
      text-transform: none;
      font-size: 20px;
      border-bottom: 0.5px solid #3d3d3d;
    }
    &.inactive {
      color: $neutral-gray;
      .title {
        border-color: $neutral-gray;
      }
    }
  }
}
</style>
